// Include jQuery
const $ = require('jquery');

require("slick-carousel/slick/slick.min.js");

/**
 * Slider Responsive only
 * @param args
 */
function sliderResponsive(args) {
  var settings = args[0];

  if ($(window).width() <= (settings.maxWidth ? settings.maxWidth : 900)) {
    settings.sliderCollection.each(function() {
      if (!$(this).hasClass('slick-initialized')) {
        var slickOptionsResponsive = [];
        if (typeof settings.breakpoints !== 'undefined') {
          $.each(settings.breakpoints, function(key, val) {
            if (val.break) {
              var currentObj = {};

              currentObj[key] = {
                breakpoint: val.break,
                settings: {
                  slidesToShow: (val.slides ? val.slides : 1),
                  slidesToScroll: (val.slides ? val.slides : 1),
                },
              };
              $.extend(slickOptionsResponsive, currentObj);
            }
          });
        }

        var slickOptionsStandard = {
          dots: false,
          infinite: false,
          arrows: true,
          speed: 300,
          rows: (settings.rows ? settings.rows : 1),
          slidesToShow: (settings.slides ? settings.slides : 2),
          slidesToScroll: (settings.slides ? settings.slides : 2),
          responsive: slickOptionsResponsive,
        };

        $(this).slick(slickOptionsStandard);
      }
    });
  } else {
    settings.sliderCollection.each(function() {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    });
  }
}



/**
 * Slideshow-Sammlungen ausgeben
 */
function sliderResponsiveCollection() {
  var slides = [];
  slides[0] = [
    {
      sliderCollection: $('.csc-uploads-3, .csc-behavior-layout-1.grid-1-spaltiger-inhalt .grid-col-1000'),
      breakpoints: [
        {
          break: 450,
        },
      ],
    },
  ];
  slides[1] = [
    {
      sliderCollection: $('.csc-behavior-layout-2.grid-1-spaltiger-inhalt .grid-col-1000'),
      slides: 4,
      rows: 2,
      breakpoints: [
        {
          break: 700,
          slides: 3,
        },
        {
          break: 600,
          slides: 2,
        },
      ],
    },
  ];
  slides[2] = [
    {
      sliderCollection: $('.csc-behavior-layout-3.grid-1-spaltiger-inhalt .grid-col-1000'),
      slides: 1,
      breakpoints: [
        {
          break: 450,
        },
      ],
    },
  ];
  slides[3] = [
    {
      sliderCollection: $('.csc-behavior-layout-4.grid-1-spaltiger-inhalt .grid-col-1000'),
      slides: 1,
      breakpoints: [
        {
          break: 900,
          slides: 3,
        },
        {
          break: 767,
          slides: 2,
        },
        {
          break: 450,
          slides: 1,
        },
      ],
    },
  ];
  // Code unten hat Probleme auf vielen Android-Geräten verursacht
  /*var slides = [
   [] = [{
   sliderCollection: $('.csc-uploads-3, .csc-behavior-layout-1.grid-1-spaltiger-inhalt .grid-col-1000'),
   breakpoints: [
   {
   break: 450
   }
   ]
   }],
   [] = [{
   sliderCollection: $('.csc-behavior-layout-2.grid-1-spaltiger-inhalt .grid-col-1000'),
   slides: 4,
   rows: 2,
   breakpoints: [
   {
   break: 700,
   slides: 3
   },
   {
   break: 600,
   slides: 2
   }
   ]
   }],
   [] = [{
   sliderCollection: $('.csc-behavior-layout-3.grid-1-spaltiger-inhalt .grid-col-1000'),
   slides: 1,
   breakpoints: [
   {
   break: 450
   }
   ]
   }],
   [] = [{
   sliderCollection: $('.csc-behavior-layout-4.grid-1-spaltiger-inhalt .grid-col-1000'),
   slides: 1,
   breakpoints: [
   {
   break: 900,
   slides: 3
   },
   {
   break: 767,
   slides: 2
   },
   {
   break: 450,
   slides: 1
   }
   ]
   }]
   ];*/

  $.each(slides, function(index, val) {
    sliderResponsive(val);
  });
}

// ready
document.addEventListener("DOMContentLoaded", function () {
  // Slick Slider

  // Slideshow-Sammlungen
  sliderResponsiveCollection();

  $('.grid-iconslider').find('.csc-grid-col').slick({
    dots: false,
    infinite: false,
    arrows: true,
    speed: 300,
    slidesToShow: 7,
    slidesToScroll: 7,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 5,
        },
      },
      {
        breakpoint: 850,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 470,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 380,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  // Sliderboxen
  var sliderBox = $('.grid-sliderbox');
  if (sliderBox.length > 0) {
    sliderBox.each(function() {
      $(this).find('.grid-col-1001 .csc-textmedia-flex').slick({
        arrows: true,
        dots: false,
        draggable: true,
        infinite: false,
        slidesToShow: 1,
        centerMode: true,
      });
    });
  }

  $('.csc-textmedia-moodimg .csc-textmedia-flex').slick({
    autoplay: true,
    infinite: true,
    speed: 4000,
    fade: true,
    pauseOnFocus: false,
    pauseOnHover: false,
    dots: false,
    arrows: false,
  });
});

$(window).on('resize', function() {
  // Slideshow-Sammlungen
  sliderResponsiveCollection();
});